import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default function renderMarkdown(markdown = '') {
  const content = DOMPurify.sanitize(marked.parse(markdown, { breaks: true, gfm: true }), {
    RETURN_DOM: true,
  });
  // Apply after sanitizing so target survives without accepting untrusted targets.
  content.querySelectorAll('a[href]').forEach((link) => {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
  return content.innerHTML;
}
